```vue
<template>
  <section
    id="services"
    class="container mx-auto p-4 space-y-8 overflow-x-hidden"
  >
    <h2
      class="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 mt-6 text-center"
      data-aos="fade-left"
      data-aos-duration="1000"
      data-aos-delay="500"
      data-aos-once="false"
    >
      O que você procura?
    </h2>

    <div
      v-for="(service, index) in services"
      :key="index"
      class="flex flex-col sm:flex-row items-center gap-6"
      :class="{ 'sm:flex-row-reverse': index % 2 !== 0 }"
    >
      <!-- Imagem do serviço -->
      <div
        class="relative overflow-hidden rounded-lg shadow-lg w-full sm:w-[741px] flex-shrink-0 cursor-pointer"
        :data-aos="index % 2 === 0 ? 'fade-right' : 'fade-left'"
        data-aos-duration="1200"
        data-aos-delay="400"
        data-aos-once="false"
      >
        <img
          :src="service.image"
          :alt="`Imagem ilustrativa do serviço ${service.name}`"
          class="w-full h-auto object-cover rounded-lg"
        />

        <div
          class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300"
          aria-hidden="true"
        >
          <p class="text-white font-bold">
            {{ service.name }}
          </p>
        </div>
      </div>

      <!-- Descrição -->
      <div
        class="flex-1 text-center sm:text-left"
        :data-aos="index % 2 === 0 ? 'fade-left' : 'fade-right'"
        data-aos-duration="1200"
        data-aos-delay="600"
        data-aos-once="false"
      >
        <h3 class="text-2xl sm:text-3xl md:text-4xl font-bold mb-2">
          {{ service.name }}
        </h3>

        <p class="text-gray-600 text-base sm:text-lg md:text-xl">
          {{ service.description }}
        </p>
      </div>
    </div>

    <!-- Frase após Clareamento -->
    <div
      class="mt-10 max-w-4xl mx-auto px-6 py-7 sm:px-10 sm:py-8 bg-purple-100 border border-purple-200 rounded-xl shadow-md text-center"
    
    >
      <p
        class="text-purple-900 text-lg sm:text-xl md:text-2xl font-semibold leading-relaxed"
      >
        Nossos especialistas irão te oferecer o melhor, com segurança,
        <br class="hidden sm:block" />
        tecnologia e experiência de quem atende há mais de 35 anos no Gama.
      </p>
    </div>
  </section>
</template>

<script setup>
import AOS from "aos";
import "aos/dist/aos.css";

// Importação otimizada das imagens
import lentesdecontato from "@/assets/images/lentesdecontato.jpg";
import implantes from "@/assets/images/implantes.jpg";
import ortodontia from "@/assets/images/Ortodontia.jpg";
import placadebruxismo from "@/assets/images/placadebruxismo.jpg";
import laserterapia from "@/assets/images/laserterapia.jpg";
import clareamento from "@/assets/images/clareamento.jpg";

const services = [
  {
    image: lentesdecontato,
    name: "Lentes de Contato",
    description:
      "As lentes de contato dental são lâminas ultrafinas feitas de porcelana ou resina que são aplicadas sobre os dentes para corrigir imperfeições estéticas. Elas são ideais para ajustar formato, cor, tamanho e alinhamento dos dentes, proporcionando um sorriso harmonioso e natural.",
  },
  {
    image: implantes,
    name: "Implantes",
    description:
      "O implante dental é uma solução definitiva e altamente eficaz para substituir dentes perdidos. Consiste em uma estrutura de titânio que é inserida no osso maxilar ou mandibular, servindo como raiz para um dente artificial. Ele proporciona estabilidade, funcionalidade e uma aparência natural ao sorriso.",
  },
  {
    image: ortodontia,
    name: "Ortodontia e Alinhadores",
    description:
      "A Ortodontia corrige problemas como dentes desalinhados, mordida cruzada e espaçamentos, melhorando a função mastigatória e prevenindo complicações futuras. Nós também trabalhamos com alinhadores estéticos.",
  },
  {
    image: placadebruxismo,
    name: "Placa de Bruxismo",
    description:
      "A placa de bruxismo é uma solução eficaz para proteger seus dentes e aliviar os desconfortos causados por um dos males do século. Aqui no IOR nós realizamos a confecção da sua placa totalmente de forma digital, aliviando desconfortos e otimizando bastante o tempo do nosso paciente.",
  },
  {
    image: laserterapia,
    name: "Laserterapia",
    description:
      "Alívio da dor e inflamação – Ideal para aftas, herpes labial e sensibilidade dentária. Pós-operatório mais rápido – Reduz o inchaço e acelera a cicatrização após cirurgias. A terapia é indolor, não invasiva e proporciona maior conforto para o paciente.",
  },
  {
    image: clareamento,
    name: "Clareamento",
    description:
      "O clareamento é uma solução simples e eficaz para devolver o brilho dos seus dentes e iluminar o seu rosto.",
  },
];

AOS.init({
  duration: 1200,
  once: false,
});
</script>


